__turbopack_context__.v({
  "barContentLayout": "HeaderDesktop-module-scss-module__ES2rZW__barContentLayout",
  "barLayoutWidth": "HeaderDesktop-module-scss-module__ES2rZW__barLayoutWidth",
  "desktopMenuWrapper": "HeaderDesktop-module-scss-module__ES2rZW__desktopMenuWrapper",
  "desktopMenuWrapperFixed": "HeaderDesktop-module-scss-module__ES2rZW__desktopMenuWrapperFixed",
  "menuItemContainer": "HeaderDesktop-module-scss-module__ES2rZW__menuItemContainer",
  "moneyBreaking": "HeaderDesktop-module-scss-module__ES2rZW__moneyBreaking",
  "navbarPlaceholder": "HeaderDesktop-module-scss-module__ES2rZW__navbarPlaceholder",
  "premiumBtn": "HeaderDesktop-module-scss-module__ES2rZW__premiumBtn",
  "primaryMenuWrapper": "HeaderDesktop-module-scss-module__ES2rZW__primaryMenuWrapper",
  "primaryNavButton": "HeaderDesktop-module-scss-module__ES2rZW__primaryNavButton",
  "secondaryMenuWrapper": "HeaderDesktop-module-scss-module__ES2rZW__secondaryMenuWrapper",
  "tertiaryMenuWrap": "HeaderDesktop-module-scss-module__ES2rZW__tertiaryMenuWrap",
  "whiteBar": "HeaderDesktop-module-scss-module__ES2rZW__whiteBar",
  "whiteBarBordered": "HeaderDesktop-module-scss-module__ES2rZW__whiteBarBordered",
});
